
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1102Dialog extends Serenity.EntityDialog<Report_1102Row, any> {
        protected getFormKey() { return Report_1102Form.formKey; }
        protected getIdProperty() { return Report_1102Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1102Row.localTextPrefix; }
        protected getNameProperty() { return Report_1102Row.nameProperty; }
        protected getService() { return Report_1102Service.baseUrl; }
        protected getDeletePermission() { return Report_1102Row.deletePermission; }
        protected getInsertPermission() { return Report_1102Row.insertPermission; }
        protected getUpdatePermission() { return Report_1102Row.updatePermission; }

        protected form = new Report_1102Form(this.idPrefix);

    }
}